import { createAction, props } from '@ngrx/store';
import { ImportMarginGridData } from 'src/app/recruiting/direct-offer-margin/direct-offer-Import-margin-grid-data.model';
import { FetchArgs } from 'src/app/shared/models/core';
import { ExpertiseModel } from 'src/app/shared/models/expertisemodel.model';

export const loadMargins = createAction('[DIRECT OFFER IMPORT MARGIN COMPONENT] Load Deals for grid');

export const loadMarginsSuccess = createAction(
    '[DIRECT OFFER IMPORT MARGIN SERVICE] Load Deals for grid Success',
    props<{ margins: ImportMarginGridData[] }>()
);

export const loadMarginsFailure = createAction(
    '[DIRECT OFFER IMPORT MARGIN SERVICE] Load Deals for grid Failure',
    props<{ error: unknown }>()
);

export const loadMarginsLookups = createAction('[DIRECT OFFER IMPORT MARGIN COMPONENT] Load Offer Lookups');

export const loadMarginsLookupsSuccess = createAction(
    '[DIRECT OFFER IMPORT MARGIN SERVICE] Load Offer Lookups Success',
    props<{ expertiseList: ExpertiseModel[] }>()
);

export const loadMarginsLookupsFailure = createAction(
    '[DIRECT OFFER IMPORT MARGIN SERVICE] Load Offer Lookups Failure',
    props<{ error: unknown }>()
);

export const setMarginsGridSearchQuery = createAction(
    '[MARGINS GRID QUERY] Set Margins Grid search query',
    props<{ searchQuery: FetchArgs }>()
);

export const createDirectOfferMarginViaImport = createAction(
    '[DIRECT OFFER IMPORT MARGIN COMPONENT] Create Direct Offer Margin Via Import',
    props<{ offerId: number; importFromMarginId: number }>()
);

export const createDirectOfferMarginViaImportSuccess = createAction(
    '[DIRECT OFFER IMPORT MARGIN SERVICE] Create Direct Offer Margin Via Import Success',
    props<{ marginId: number }>()
);

export const createDirectOfferMarginViaImportFailure = createAction(
    '[DIRECT OFFER IMPORT MARGIN SERVICE] Create Direct Offer Margin Via Import Failure',
    props<{ error: unknown }>()
);

export const resetMarginId = createAction(
    '[CREATED DIRECT OFFER MARGIN VIA IMPORT] Reset Margin Id ',
    props<{ marginId: number }>()
);
